import { sparePartsList } from "constants/spareParts";

const initialState = {
  sparePartsList: {},
};

const sparePart = (state = initialState, action) => {
  switch (action.type) {
    case sparePartsList:
      return { ...state, sparePartsList: action.payload };
    default:
      return state;
  }
};

export default sparePart;
